import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import LogoMark from "@/components/LogoMark";
import { toast } from "sonner";

export default function Register() {
    const { register } = useAuth();
    const nav = useNavigate();
    const [form, setForm] = useState({ name: "", email: "", password: "", union_name: "" });
    const [err, setErr] = useState("");
    const [loading, setLoading] = useState(false);

    const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

    const submit = async (e) => {
        e.preventDefault();
        if (form.password.length < 8) {
            setErr("Password must be at least 8 characters.");
            return;
        }
        setErr("");
        setLoading(true);
        const res = await register(form);
        setLoading(false);
        if (!res.ok) {
            setErr(res.error);
            return;
        }
        toast.success("Account created. Welcome to Bradshaw Solutions.");
        nav("/portal", { replace: true });
    };

    return (
        <div className="min-h-[80vh] flex items-center justify-center px-6 py-16" data-testid="register-page">
            <div className="w-full max-w-md">
                <div className="flex justify-center mb-8"><LogoMark size={56} /></div>
                <div className="bg-ink-800 border border-white/10 rounded-2xl p-8">
                    <div className="label-tag">Union sign-up</div>
                    <h1 className="mt-3 font-display text-3xl font-bold">Create your portal account.</h1>
                    <form onSubmit={submit} className="mt-8 space-y-5" data-testid="register-form">
                        <Field label="Full name" required>
                            <input required data-testid="register-name" value={form.name} onChange={upd("name")} className="reg-input" />
                        </Field>
                        <Field label="Email" required>
                            <input type="email" required data-testid="register-email" value={form.email} onChange={upd("email")} className="reg-input" />
                        </Field>
                        <Field label="Union / Local">
                            <input data-testid="register-union" value={form.union_name} onChange={upd("union_name")} className="reg-input" placeholder="e.g., UFCW Local 8" />
                        </Field>
                        <Field label="Password (min 8 chars)" required>
                            <input type="password" required data-testid="register-password" value={form.password} onChange={upd("password")} className="reg-input" />
                        </Field>
                        {err && <div className="text-sm text-red-400" data-testid="register-error">{err}</div>}
                        <button
                            type="submit"
                            disabled={loading}
                            data-testid="register-submit-btn"
                            className="w-full px-7 py-3.5 rounded-full bg-gold-500 text-ink-900 font-bold uppercase tracking-wider text-sm hover:bg-gold-400 disabled:opacity-60"
                        >
                            {loading ? "Creating…" : "Create account"}
                        </button>
                    </form>
                    <p className="mt-6 text-sm text-white/60 text-center">
                        Already have an account? <Link to="/login" className="text-gold-500">Sign in</Link>
                    </p>
                </div>
            </div>
            <style>{`.reg-input { width:100%; background:#0A0A0A; border:1px solid rgba(255,255,255,0.12); border-radius:10px; padding:12px 14px; color:#fff; }`}</style>
        </div>
    );
}

function Field({ label, required, children }) {
    return (
        <label className="block">
            <span className="block text-xs tracking-[0.2em] uppercase text-white/60 mb-2">
                {label}{required ? " *" : ""}
            </span>
            {children}
        </label>
    );
}
